import React, { useEffect, useState, useMemo } from "react";
import PropTypes from "prop-types";
import { isEmpty } from "lodash";
import
  {
    CardBody,
    Container,
    Row,
    Card,
    Table,
    Badge,
    Col,
    Alert,
  } from "reactstrap";

//Import Breadcrumb
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import TableContainer from "../../../Components/Common/TableContainer";
import dummyImg from "../../../assets/images/users/user-dummy-img.jpg";

import
  {
    getCoursesClientIn,
    getParainageInfoClient,
  } from "../../../common/data";

// import Revenue from "../../Dashboard/Revenue";

//redux
import { useSelector, useDispatch } from "react-redux";
import { Link, Redirect, useParams, withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { ToastContainer, toast } from "react-toastify";
import axiosInstance from "../../../axiosConfig";
import Loader from "../../../Components/Common/Loader";
import StatistiquesDetail from "../../../Components/Common/StatistiquesDetail";
import Key from "../../../key";


const ImageWithFallback = ( { src, fallback, ...props } ) =>
{
  const [ imgSrc, setImgSrc ] = useState( fallback );

  useEffect( () =>
  {
    if ( src )
    {
      fetch( src, { method: "HEAD" } )
        .then( ( res ) =>
        {
          if ( !res.ok ) throw new Error( "Image not found" );
          setImgSrc( src );
        } )
        .catch( () => setImgSrc( fallback ) );
    } else
    {
      setImgSrc( fallback );
    }
  }, [ src, fallback ] );

  return <img src={ imgSrc } onError={ () => setImgSrc( fallback ) } { ...props } />;
};

const ClientsDetail = ( props ) =>
{
  const [ loading, setLoading ] = useState( true );

  //Début code pour get le client sélectionné
  const clientId = useParams( "id" );
  // console.log( "numcon", clientId.id );

  const url = process.env.REACT_APP_API_URL;
  const token = JSON.parse( localStorage.getItem( "authUser" ) )
    ? JSON.parse( localStorage.getItem( "authUser" ) ).access
    : null;
  // if ( token )
  //   axios.defaults.headers.common[ "Authorization" ] = "Bearer " + token;

  const [ selectclient, setSelectClient ] = useState( {} );
  const [ clientCoursesIn, setClientCoursesIn ] = useState( [] );
  const [ clientParainage, setClientParainage ] = useState( {
    parainee: 0,
    revenus: 0,
  } );

  useEffect( () =>
  {
    const fetchData = async () =>
    {
      try
      {
        const client_data = await axiosInstance.get(
          `/clientdetail/?id=${ clientId.id }`
        );

        if ( client_data?.data )
        {
          // const data = await axios.get( `https://stepnode.inawo.pro/clientdetail/?id=${ clientId.id }/` );
          const clientData = client_data.data.data;
          setSelectClient( clientData );

          //   console.log("clientData: ", clientData);

          const coursesClientIn = await getCoursesClientIn( clientData.user_id );
          const sortClientCourse = coursesClientIn.sort( ( a, b ) =>
          {
            // Prioriser les noms non vides
            const aHasName =
              a.last_name.trim() !== "" || a.first_name.trim() !== "";
            const bHasName =
              b.last_name.trim() !== "" || b.first_name.trim() !== "";
            return aHasName - bHasName; // Les noms non vides passent en premier
          } );
          //   console.log("sortClientCourse: ", sortClientCourse);
          // console.log("coursesClientIn: ", coursesClientIn);
          setClientCoursesIn( coursesClientIn );

          const parraingeInfo = await getParainageInfoClient(
            clientData.user_id
          );
          setClientParainage( {
            parainee: parraingeInfo.filleuls,
            revenus: parraingeInfo.gains,
          } );
        }

        // console.log("revenuCoursesClient: ", revenuCoursesClient);
      } catch ( err )
      {
        console.error(
          `Erreur de récupération des données du client ${ clientId.id }: `,
          err
        );
      }
      setLoading( false );
    };
    fetchData();
  }, [ clientId, url ] );

  //Fin code

  const [ clientList, setClientList ] = useState( [] );

  useEffect( () =>
  {
    // console.log( "selectclient", selectclient );
    if ( !isEmpty( selectclient ) ) setSelectClient( selectclient );
  }, [ selectclient ] );

  function formatDate ( date )
  {
    const dateObject = new Date( date ).toLocaleDateString( "fr-FR", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      timeZoneName: "short",
    } );
    return dateObject;
  }

  const columnsTable = useMemo(
    () => [
      {
        Header: "Nom Conducteur",
        accessor: "last_name",
        filterable: false,
        Cell: ( cell ) =>
        {
          return cell.row.original.last_name;
        },
      },
      {
        Header: "Prénom Conducteur",
        accessor: "first_name",
        filterable: false,
        Cell: ( cellProps ) =>
        {
          return cellProps.row.original.first_name;
        },
      },
      {
        Header: "Date",
        accessor: "date",
        filterable: false,
        Cell: ( cellProps ) =>
        {
          return formatDate( cellProps.row.original.date );
        },
      },

      {
        Header: "status",
        accessor: "status",
        filterable: true,
        // Cell: (cellProps) => {
        //   return formatDate(cellProps.row.original.status);
        // },
      },
      {
        Header: "Type de course",
        accessor: "type",
        filterable: true,
      },
    ],
    []
  );

  const columnStatistique = [
    {
      title: "Courses",
      prefix: "",
      suffix: "",
      value: clientCoursesIn.length || 0,
    },
    {
      title: "Filleuls",
      prefix: "",
      suffix: "",
      value: clientParainage.parainee || 0,
    },
    {
      title: "Gains",
      prefix: "XOF ",
      suffix: "",
      value: clientParainage.revenus || 0,
    },
  ];

  document.title = "Détails Clients | Takci";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb
            title={ props.t( "Détails Client" ) }
            pageTitle="Clients"
            pageTitleLink="/client"
          />

          <Row className="g-2">
            {/* { error && error ? <Alert color="danger">{ error }</Alert> : null }
            { success ? <Alert color="success"> { success }</Alert> : null } */}
            { !loading ? (
              Object.keys( selectclient ).length > 0 ? (
                <>
                  <Row className="mb-3">
                    <Card
                      className="h-100 w-100 shadow-lg"
                      style={ { borderLeft: "5px solid #01064a" } }
                    >
                      <CardBody>
                        <div className="d-flex">
                          <div className="mx-3">
                            <ImageWithFallback
                              src={ Key.photoURL + selectclient.photo }
                              fallback={ dummyImg }
                              alt=""
                              className="avatar-md rounded-circle img-thumbnail"
                            />

                            {/* {selectclient.photo} */ }
                          </div>
                          <div className="flex-grow-1 align-self-center">
                            <div className="text-muted">
                              <h3
                                className="fw-bolder"
                                style={ { color: "#01064a" } }
                              >
                                { selectclient.last_name || (
                                  <Badge color="danger">Non renseignée</Badge>
                                ) }{ " " }
                                { selectclient.first_name || (
                                  <Badge color="danger">Non renseignée</Badge>
                                ) }
                              </h3>
                              <p className="mb-1">
                                { props.t( "Customers" ) +
                                  " " +
                                  ( selectclient.id || 1 ) }
                              </p>
                            </div>
                          </div>
                        </div>
                      </CardBody>
                    </Card>
                  </Row>

                  <Col xxl={ 4 }>
                    <Card className="h-100 w-100">
                      <CardBody>
                        <h5 className="card-title mb-3">
                          { props.t( "Personal details" ) }
                        </h5>
                        <div className="table-responsive">
                          <Table className="table-borderless mb-0">
                            <tbody>
                              <tr>
                                <th className="ps-0" scope="row">
                                  { props.t( "Full Name" ) }:
                                </th>
                                <td className="text-muted">
                                  { selectclient.last_name || (
                                    <Badge color="danger">Non renseignée</Badge>
                                  ) }{ " " }
                                  { selectclient.first_name || (
                                    <Badge color="danger">Non renseignée</Badge>
                                  ) }
                                </td>
                              </tr>
                              <tr>
                                <th className="ps-0" scope="row">
                                  { props.t( "Phone number" ) }:
                                </th>
                                <td className="text-muted">
                                  { ( selectclient.telephone && (
                                    <a href={ `tel: ${ selectclient.telephone }` }>
                                      { selectclient.telephone }
                                    </a>
                                  ) ) || (
                                      <Badge color="danger">Non renseignée</Badge>
                                    ) }
                                </td>
                              </tr>
                              <tr>
                                <th className="ps-0" scope="row">
                                  { props.t( "Email" ) }:
                                </th>
                                <td className="text-muted">
                                  { ( selectclient.email && (
                                    <a href={ `mailto: ${ selectclient.email }` }>
                                      { selectclient.email }
                                    </a>
                                  ) ) || (
                                      <Badge color="danger">Non renseignée</Badge>
                                    ) }
                                </td>
                              </tr>
                              <tr>
                                <th className="ps-0" scope="row">
                                  { props.t( "Joining Date" ) }
                                </th>
                                <td className="text-muted">
                                  { ( selectclient.created_at &&
                                    formatDate( selectclient.created_at ) ) || (
                                      <Badge color="danger">Non renseignée</Badge>
                                    ) }
                                </td>
                              </tr>
                            </tbody>
                          </Table>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>

                  <Col xxl={ 8 }>
                    <Card className="h-100 w-100">
                      <StatistiquesDetail data={ columnStatistique } />
                      { clientCoursesIn.length > 0 ? (
                        <Card>
                          <CardBody>
                            <div className="table-card gridjs-border-none pb-2">
                              <TableContainer
                                columns={ columnsTable }
                                data={ clientCoursesIn || [] }
                                isGlobalFilter={ false }
                                isAddUserList={ false }
                                customPageSize={ 10 }
                                divClass="table-responsive"
                                tableClass="mb-0 table-borderless"
                                theadClass="table-light text-muted"
                              />
                            </div>
                          </CardBody>
                        </Card>
                      ) : (
                        <Alert color="warning">
                          Aucun historique de course disponible.
                        </Alert>
                      ) }
                    </Card>
                  </Col>
                </>
              ) : (
                <Col
                  lg="12"
                  className="p-4 border-top border-top-dashed justify-center"
                >
                  <h6 className="text-muted text-uppercase fw-semibold mb-4">
                    Aucun Client associé
                  </h6>
                </Col>
              )
            ) : (
              <>
                <div className="text-center my-3">
                  <Loader style={ { color: "#014c94" } } />
                  <h2>Chargement...</h2>
                </div>
              </>
            ) }
          </Row>
          <ToastContainer closeButton={ false } />
        </Container>
      </div>
    </React.Fragment>
  );
};

ClientsDetail.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};
export default withRouter( withTranslation()( ClientsDetail ) );
